import Vue from 'vue';

type PrivacyType = 'resident' | 'admin' | 'proposal' | 'idea';

export default Vue.extend({
	computed: {
		privacyType(): PrivacyType | null {
			return (this.$route.query.type as PrivacyType) || null;
		},
		privacyItems(): string {
			const type = this.privacyType;
			switch (type) {
				case 'resident':
					return '이름, 연락처(유선전화 또는 휴대폰), 이메일, 아파트명, 동호수';
				case 'admin':
					return '이름, 연락처(유선전화 또는 휴대폰), 이메일, 직급, 회사명, 현장명';
				case 'proposal':
					return '이름, 연락처(유선전화 또는 휴대폰), 이메일, 회사명, 부서/직급';
				case 'idea':
					return '이름, 연락처(유선전화 또는 휴대폰), 이메일';
				default:
					return '이름, 연락처(유선전화 또는 휴대폰), 이메일';
			}
		}
	}
});

